export const getUrlDomain = url => {
  if (!url) return null;
  const match = url.match(/(?:ws:\/\/|wss:\/\/)([^\/]+)/);

  return match ? match[1] : null;
};
